import { LOCATION_REQUIRED } from '@/constants/MessageConstants'
import * as Yup from 'yup'

export const LocationValidationSchema = Yup.object().shape({
  description: Yup.string().required(LOCATION_REQUIRED),
  placeId: Yup.string().notRequired(),
})

export const createLocationValidationSchema = (t: any) => {
  return Yup.object().shape({
    description: Yup.string().required(t('constant.locationRequired')),
    placeId: Yup.string().notRequired(),
  })
}
